import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsInputs from "../../../src/SubTabsInputs.js";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import SubTabsWarehouses from '../../SubTabsWarehouses.js';
import axiosService from '../../helpers/axios';
import { SatelliteContext } from '../../context/SatelliteContext';
import { getSatelliteApiParam, applySatelliteQueryToUrl, satellitePayloadValue, displaySatellite } from '../../helpers/satellite';

  export default class WarehousesTransferts extends Component{
    static contextType = SatelliteContext; 

    constructor(props){
      super(props);

      this.state={
          transferts:[],
          modalTitle:"",

          // ADD THESE NEW PAGINATION VARIABLES:
          currentPageProcurement: 1,
          totalPagesProcurement: 1,
          pageSizeProcurement: 100,
          nextPageUrlProcurement: null,
          previousPageUrlProcurement: null,
          
            transfertid: 0,
            yearid: 0,
            from_warehouseid: 0,
            to_warehouseid: 0,
            productid: 0,
            july:"",
            august: "",
            september:"",
            october: "",
            november:"",
            december:"",
            january: "",
            february: "",
            march: "",
            april: "",
            may: "",
            june: "",
            povalidatedjuly: false,
		      povalidatedaugust: false,
		      povalidatedseptember: false,
		      povalidatedoctober: false,
		      povalidatednovember: false,
		      povalidateddecember: false,
		      povalidatedjanuary: false,
		      povalidatedfebruary: false,
		      povalidatedmarch: false,
		      povalidatedapril: false,
		      povalidatedmay: false,
		      povalidatedjune: false,
            from_warehouse: {
              warehouseid: 0,
              warehousename: "",
              countryid: 0
            },
            to_warehouse: {
              warehouseid: 0,
              warehousename: "",
              countryid: 0
            },
            year: {
              yearid: 0,
              fyname: "",
              isactive: true
            },
            product: {
              productid: 0,
              sapcode: "",
              productdescription: "",
              itemtype: {
                itemtypeid: 0,
                itemtypename: ""
              }
            },
            comment:"",
            satellite:"",
 
    kits:[],
    products:[],
    productLabels:[],
    productlabelname:"",
    

          
          TransfertIdFilter:"",
          ProductIdFilter:"",
          ProductDescriptionFilter:"",
          ItemTypeFilter:"",
          FiscalYearFilter:"",
          RegionNameFilter:"",
          CountryNameFilter:"",
          FromWarehouseNameFilter:"",
          ToWarehouseNameFilter:"",
          TransfertCommentFilter:"",
          transfertsWithoutFilter:[],


       
          
          ForecastCommentOFilter:"",
          CurrentYearFilter:"",
          
          forecastsHistoryWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [], 
          productdescriptions: [],
          warehouseNames: [],
          toWarehouseNames: [],
          loading: true,
          loadingProcurement: true,
          isEditClicked: false,
          fiscalYear:"",
          fiscalMonth:"",

          stockprocurement:[],
         
          stockviewid:0,
          fyname_o:"",
          regionname_o:"",
          warehousename_o:"",
          productid_o:0,
          sapcode_o:"",
          productdescription_o:"",
          itemtypename_o:"",
          july_o:"",
          august_o:"",
          september_o:"",
          october_o: "",
          november_o: "",
          december_o: "",
          january_o: "",
          february_o: "",
          march_o: "",
          april_o: "",
          may_o: "",
          june_o:"",
          stockprocurementWithoutFilter:[],
          isEditClicked: false,
          StockViewIdFilter:"",
          FiscalYearOFilter:"",
          RegionNameOFilter:"",
          WarehouseNameOFilter:"",
          ProductIdOFilter:"",
          ProductDescriptionOFilter:"",
          ItemTypeNameOFilter:"",
          fiscalYear:"",
          fiscalMonth:"",
          purchasedContainers : [],

          SapcodeDupNames:[],
          SapcodeDupDescriptionNames:[],
          SapcodeNames:[],
          SapcodeDescriptionNames:[],

          transfertpodelayid: 0,
          transfertpodelay: "",
          transfertpodelayids: [],
          transfertpodelays:[]
          

      }

      this.handleNextPageProcurement = this.handleNextPageProcurement.bind(this);
      this.handlePreviousPageProcurement = this.handlePreviousPageProcurement.bind(this);
      this.searchStockProcurement = this.searchStockProcurement.bind(this);
      this.clearFiltersProcurement = this.clearFiltersProcurement.bind(this);

  }


  getCurrentFinancialYearAndMonth() {
    const today = new Date();
    let fiscalYear = "";
    let fiscalMonth = "";
  
    // Determine fiscal year
    if ((today.getMonth() + 1) <= 6) {
      fiscalYear = (today.getFullYear());
    } else {
      fiscalYear = today.getFullYear() + 1;
    }
  
    // Determine fiscal month
    fiscalMonth = (today.getMonth() + 1); // Adding 1 as months are 0-indexed
  
    return {
      fiscalYear: fiscalYear,
      fiscalMonth: fiscalMonth
    };
  }


  
calculateDateFromFiscal(fiscalYear, fiscalMonth, leadTime) {

  // Convert fiscalYear to integer
  fiscalYear = parseInt(fiscalYear);
  // Subtract lead time from fiscal month
  let adjustedFiscalMonth = fiscalMonth - leadTime;

  // Adjust fiscal year and month if necessary
  if (adjustedFiscalMonth < 1) {
      adjustedFiscalMonth += 12;
      if(adjustedFiscalMonth>=7){
        fiscalYear = fiscalYear;
      } else{
        fiscalYear--;
      }
      ;
  }

  // Determine calendar month and year
  let calendarMonth = adjustedFiscalMonth;
  let calendarYear = fiscalYear;

  // Adjust calendar year if the month is greater than 12
  if (calendarMonth > 12) {
      calendarMonth -= 12;
      calendarYear++;
  }

  // Return the calculated date
  return {
      year: calendarYear,
      month: calendarMonth
  };
}


formatCalculatedDate(calculatedDate) {
  // Format the date with day 28
  return `${calculatedDate.month}-${calculatedDate.year}-28`;
}



  FilterFn(){
    var TransfertIdFilter = this.state.TransfertIdFilter;
    var ProductIdFilter = this.state.ProductIdFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var ItemTypeFilter = this.state.ItemTypeFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var FromWarehouseNameFilter = this.state.FromWarehouseNameFilter;
    var ToWarehouseNameFilter = this.state.ToWarehouseNameFilter;
    var TransfertCommentFilter = this.state.TransfertCommentFilter;

    var filteredData=this.state.transfertsWithoutFilter.filter(
        function(el){
            return el.from_warehouse?.warehousename.toString().toLowerCase().includes(
                FromWarehouseNameFilter.toString().trim().toLowerCase()
            )&& 
            el.to_warehouse?.warehousename.toString().toLowerCase().includes(
              ToWarehouseNameFilter.toString().trim().toLowerCase()
          )&&  
                el.year?.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.product?.productdescription.toString().toLowerCase().includes(
                ProductDescriptionFilter.toString().trim().toLowerCase()
            )&&  
                el.transfertid.toString().toLowerCase().includes(
                TransfertIdFilter.toString().trim().toLowerCase()
            )&&  
            el.product?.sapcode.toString().toLowerCase().includes(
            ProductIdFilter.toString().trim().toLowerCase()
        )&&  
        el.product?.itemtype?.itemtypename.toString().toLowerCase().includes(
        ItemTypeFilter.toString().trim().toLowerCase()
    )&&  
    el.comment.toString().toLowerCase().includes(
    TransfertCommentFilter.toString().trim().toLowerCase()
)
        }
    );

    this.setState({transferts:filteredData});

}



sortResult(prop,asc){
  var sortedData=this.state.forecastsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({forecasts:sortedData});

}



FilterFnO(){
  var RegionNameOFilter = this.state.RegionNameOFilter;
  var WarehouseNameOFilter = this.state.WarehouseNameOFilter;
  var FiscalYearOFilter = this.state.FiscalYearOFilter;
  var ProductDescriptionOFilter = this.state.ProductDescriptionOFilter;
  var StockViewIdFilter = this.state.StockViewIdFilter;
  var ItemTypeName0Filter = this.state.ItemTypeNameOFilter;
  var ProductIdOFilter = this.state.ProductIdOFilter;


  var filteredData=this.state.stockprocurementWithoutFilter.filter(
      function(el){
          return el.warehousename_o.toString().toLowerCase().includes(
              WarehouseNameOFilter.toString().trim().toLowerCase()
          )&&  
              el.fyname_o.toString().toLowerCase().includes(
              FiscalYearOFilter.toString().trim().toLowerCase()
          )&&  
              el.stockviewid.toString().toLowerCase().includes(
              StockViewIdFilter.toString().trim().toLowerCase()
          )&&  
          el.regionname_o.toString().toLowerCase().includes(
            RegionNameOFilter.toString().trim().toLowerCase()
      )&&  
      el.productdescription_o.toString().toLowerCase().includes(
        ProductDescriptionOFilter.toString().trim().toLowerCase()
  )&&  
  el.itemtypename_o.toString().toLowerCase().includes(
    ItemTypeName0Filter.toString().trim().toLowerCase()
)&&  
el.sapcode_o.toString().toLowerCase().includes(
  ProductIdOFilter.toString().trim().toLowerCase()
)
      }
  );

  this.setState({stockprocurement:filteredData});

}

sortResultO(prop,asc){
var sortedData=this.state.stockprocurementWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

this.setState({stockprocurement:sortedData});

}



changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}



changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }



changeFromWarehouseNameFilter = (e)=>{
    this.state.FromWarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

  changeToWarehouseNameFilter = (e)=>{
    this.state.ToWarehouseNameFilter=e.target.value;
    this.FilterFn();
  }


changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }



changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }

  changeProductIdFilter = (e)=>{
    this.state.ProductIdFilter=e.target.value;
    this.FilterFn();
  }




  changeItemTypeFilter = (e)=>{
    this.state.ItemTypeFilter=e.target.value;
    this.FilterFn();
  }

changeTransfertIdFilter = (e)=>{
    this.state.TransfertIdFilter=e.target.value;
    this.FilterFn();
  }

  changeTransfertCommentFilter = (e)=>{
    this.state.TransfertCommentFilter=e.target.value;
    this.FilterFn();
  }

  changeWarehouseNameOFilter = (e)=>{
    this.state.WarehouseNameOFilter=e.target.value;
    this.FilterFnO();
  }


  changeRegionNameOFilter = (e)=>{
    this.state.RegionNameOFilter=e.target.value;
    this.FilterFnO();
  }


  


refreshList = () => {
    const params = {};
    const sat = getSatelliteApiParam(this.context?.satellite);
    if (sat) params.satellite = sat;
    axiosService.get('/transferts/', { params })
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ transferts: data, transfertsWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };


refreshListProcurement = (url = null) => {
  const apiUrl = applySatelliteQueryToUrl(url || '/stockprocurement/', this.context?.satellite);

  axiosService.get(apiUrl)
    .then((response) => {
      const data = response.data;
      const results = data?.results ?? data;
      const totalPagesProcurement = Math.ceil((data?.count || 0) / this.state.pageSizeProcurement);

      this.setState({
        stockprocurement: results,
        stockprocurementWithoutFilter: results,
        loadingProcurement: false,
        nextPageUrlProcurement: data?.next ?? null,
        previousPageUrlProcurement: data?.previous ?? null,
        totalPagesProcurement: totalPagesProcurement
      });
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      this.setState({ loadingProcurement: false });
    });
};


// 3. ADD NEXT PAGE HANDLER
handleNextPageProcurement = () => {
  if (this.state.nextPageUrlProcurement) {
    this.setState({ 
      loadingProcurement: true,
      currentPageProcurement: this.state.currentPageProcurement + 1 
    });
    this.refreshListProcurement(this.state.nextPageUrlProcurement);
  }
};

// 4. ADD PREVIOUS PAGE HANDLER
handlePreviousPageProcurement = () => {
  if (this.state.previousPageUrlProcurement) {
    this.setState({ 
      loadingProcurement: true,
      currentPageProcurement: this.state.currentPageProcurement - 1 
    });
    this.refreshListProcurement(this.state.previousPageUrlProcurement);
  }
};

// 5. ADD SEARCH METHOD FOR FILTERED PAGINATION:

searchStockProcurement = () => {
  const {
    FiscalYearOFilter,
    WarehouseNameOFilter,
    ProductIdOFilter,
    ProductDescriptionOFilter,
    ItemTypeNameOFilter
  } = this.state;

  // Build query parameters
  const queryParams = new URLSearchParams();
  
  if (FiscalYearOFilter) {
    queryParams.append('year', FiscalYearOFilter);
  }
  if (WarehouseNameOFilter) {
    queryParams.append('warehouse', WarehouseNameOFilter);
  }
  if (ProductIdOFilter) {
    queryParams.append('sapcode', ProductIdOFilter);
  }
  if (ProductDescriptionOFilter) {
    queryParams.append('product', ProductDescriptionOFilter);
  }
  if (ItemTypeNameOFilter) {
    queryParams.append('itemtype', ItemTypeNameOFilter);
  }
  const satCtx = getSatelliteApiParam(this.context?.satellite);
  if (satCtx) queryParams.append('satellite', satCtx);

  // Show loading state
  this.setState({ loadingProcurement: true });

  // Call the API
  const queryString = queryParams.toString();
  const endpoint = `/stockprocurement/${queryString ? '?' + queryString : ''}`;
  axiosService.get(endpoint)
    .then((response) => {
      const data = response.data?.results ?? response.data;
      this.setState({ 
        stockprocurement: data.results || data, 
        stockprocurementWithoutFilter: data.results || data,
        loadingProcurement: false,
        nextPageUrlProcurement: data.next,
        previousPageUrlProcurement: data.previous,
        totalPagesProcurement: data.count ? Math.ceil(data.count / this.state.pageSizeProcurement) : 1,
        currentPageProcurement: 1
      });
    })
    .catch((error) => {
      console.error('Error searching stock procurement:', error);
      alert('Failed to search stock procurement');
      this.setState({ loadingProcurement: false });
    });
};

// 6. ADD CLEAR FILTERS METHOD:

clearFiltersProcurement = () => {
  this.setState({
    FiscalYearOFilter: "",
    WarehouseNameOFilter: "",
    ProductIdOFilter: "",
    ProductDescriptionOFilter: "",
    ItemTypeNameOFilter: "",
    StockViewIdFilter: "",
    RegionNameOFilter: ""
  }, () => {
    // Clear all input fields in the DOM
    const filterInputs = document.querySelectorAll('.form-control');
    filterInputs.forEach(input => {
      if (input.placeholder === 'Filter') {
        input.value = '';
      }
    });
    // Show loading state
    this.setState({ loadingProcurement: true });
    // Reload all data after clearing filters
    this.refreshListProcurement();
  });
};

// 7. UPDATE YOUR FILTER CHANGE HANDLERS TO NOT CALL FilterFnO:
// Replace your existing handlers with these:

changeWarehouseNameOFilter = (e) => {
  this.setState({ WarehouseNameOFilter: e.target.value });
}

changeRegionNameOFilter = (e) => {
  this.setState({ RegionNameOFilter: e.target.value });
}

changeFiscalYearOFilter = (e) => {
  this.setState({ FiscalYearOFilter: e.target.value });
}

changeItemTypeNameOFilter = (e) => {
  this.setState({ ItemTypeNameOFilter: e.target.value });
}

changeProductDescriptionOFilter = (e) => {
  this.setState({ ProductDescriptionOFilter: e.target.value });
}

changeProductIdOFilter = (e) => {
  this.setState({ ProductIdOFilter: e.target.value });
}

changeStockViewIdFilter = (e) => {
  this.setState({ StockViewIdFilter: e.target.value });
}


fetchRegionNames() {
  axiosService.get('/regionnames/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const regionNames = data.map(item => item.regionname);
      this.setState({ regionNames: regionNames });
    })
    .catch(error => {
      console.error("Error fetching region names:", error);
    });
}


fetchCountryNames() {
  axiosService.get('/countries/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const countryNames = filteredData.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}

fetchFiscalYears() {
    axiosService.get('/years/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const fiscalYears = filteredData.map(item => item.fyname);
        this.setState({ fiscalYears: fiscalYears });
      })
      .catch(error => {
        console.error("Error fetching fiscal years:", error);
      });
  }

  fetchProductDescriptions() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const productdescriptions = filteredData.map(item => item.productdescription);
        this.setState({ productdescriptions: productdescriptions });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }

  fetchWarehouseNames() {
    axiosService.get('/warehouses/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const warehouseNames = filteredData.map(item => item.warehousename);
        this.setState({ warehouseNames: warehouseNames });
      })
      .catch(error => {
        console.error("Error fetching warehouse names:", error);
      });
  }

  fetchToWarehouseNames() {
    axiosService.get('/warehouses/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const toWarehouseNames = filteredData.map(item => item.warehousename);
        this.setState({ toWarehouseNames: toWarehouseNames });
      })
      .catch(error => {
        console.error("Error fetching warehouse names:", error);
      });
  }

handleInput = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/;
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/[^0-9]/g, '');
    }
  };

  fetchProducts() {
    axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
      .then((response) => {
        const data = response.data?.results ?? response.data;
        // Filter the data where purchasetypeid is equal to 1
        const filteredData = data.filter((item) => item.productlabelid === 1 && item.isactive === true);
  
        // Extract unique warehouseid values from the filtered data
        const products = filteredData.map((item) => item.productdescription);
  
        this.setState({ products: products });
      })
      .catch((error) => {
        console.error('Error fetching Products data:', error);
      });
  }

  fetchKits() {
    axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
      .then((response) => {
        const data = response.data?.results ?? response.data;
        // Filter the data where purchasetypeid is equal to 1
        const filteredData = data.filter((item) => item.productlabelid === 2 &&  item.isactive === true);
  
        // Extract unique warehouseid values from the filtered data
        const kits = filteredData.map((item) => item.productdescription);
  
        this.setState({ kits: kits });
      })
      .catch((error) => {
        console.error('Error fetching Products data:', error);
      });
  }

  fetchProductLables() {
    axiosService.get('/productlabels/') // Replace with the appropriate API endpoint for products
      .then((response) => {
        const data = response.data?.results ?? response.data;
       
        const productLabels = data.map((item) => item.productlabelname);
  
        this.setState({ productLabels: productLabels });
      })
      .catch((error) => {
        console.error('Error fetching ProductLabels data:', error);
      });
  }

  formatUpdateDate(update_y) {
    if (!update_y) {
      return 'N/A'; // Handle the case where update_y is not available
    }

    const parsedDate = new Date(update_y);
    const formattedDate = parsedDate.toLocaleDateString(); // Adjust the format as needed

    return formattedDate;
  }

    
fetchSapcodeDupNames() {
  axiosService.get('/defaultkits/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const SapcodeDupNames = filteredData.map(item => item.sapcodedup);

      const sapcodeToProductDescriptionMap = {};
      const sapcodeToSatelliteMap = {};
      filteredData.forEach(item => {
        sapcodeToProductDescriptionMap[item.sapcodedup] = item.productdescription;
        sapcodeToSatelliteMap[item.sapcodedup] = item.satellite ?? '';
      });

      this.setState({ SapcodeDupNames: SapcodeDupNames, SapcodeDupDescriptionNames: sapcodeToProductDescriptionMap, SapcodeDupSatelliteNames: sapcodeToSatelliteMap });
    })
    .catch(error => {
      console.error("Error fetching product sapcode:", error);
    });
}

findProductDescriptionForSapcodeDup(sapcodedup) {
  const productDescriptionMap = this.state.SapcodeDupDescriptionNames;
  return productDescriptionMap[sapcodedup] || "Kit not found";
}


fetchProductNames() {
  axiosService.get('/defaultitems/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const productNames = filteredData.map(item => item.productdescription);
      this.setState({ productNames: productNames });
    })
    .catch(error => {
      console.error("Error fetching product names:", error);
    });
}

fetchSapcodeNames() {
  axiosService.get('/defaultitems/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const SapcodeNames = filteredData.map(item => item.sapcode);

      const sapcodeToProductDescriptionMap = {};
      const sapcodeToSatelliteMap = {};
      filteredData.forEach(item => {
        sapcodeToProductDescriptionMap[item.sapcode] = item.productdescription;
        sapcodeToSatelliteMap[item.sapcode] = item.satellite ?? '';
      });

      this.setState({ SapcodeNames: SapcodeNames, SapcodeDescriptionNames: sapcodeToProductDescriptionMap, SapcodeSatelliteNames: sapcodeToSatelliteMap });
    })
    .catch(error => {
      console.error("Error fetching product sapcode:", error);
    });
}

findProductDescriptionForSapcode(sapcode) {
  const productDescriptionMap = this.state.SapcodeDescriptionNames;
  return productDescriptionMap[sapcode] || "Product not found";
}

findSatelliteForSapcodeDup(sapcodedup) {
  return this.state.SapcodeDupSatelliteNames?.[sapcodedup] ?? '';
}

findSatelliteForSapcode(sapcode) {
  return this.state.SapcodeSatelliteNames?.[sapcode] ?? '';
}

fetchTransfertPoDelay() {
  axiosService.get('/transfertpodelay/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const transfertpodelayIDS = data.map(item => item.transfertpodelayid);

      const transfertPoDelayMap = {};
      data.forEach(item => {
        transfertPoDelayMap[item.transfertpodelayid] = item.transfertpodelay;
      });

      this.setState({ transfertpodelayids: transfertpodelayIDS,transfertpodelays:transfertPoDelayMap  });
    })
    .catch(error => {
      console.error("Error fetching transfertpo ids:", error);
    });
}

findTransfertPoDelayID(transfertpodelayid) {
  const transfertPoDelayMap = this.state.transfertpodelays;
  return transfertPoDelayMap[transfertpodelayid] || "transfertpodelay not found";
}


componentDidUpdate(_prevProps, _prevState) {
  const sat = this.context?.satellite;
  if (this._lastTransfertsSatellite !== sat) {
    this._lastTransfertsSatellite = sat;
    this.setState({ loading: true });
    this.refreshList();
    this.searchStockProcurement();
  }
}

componentDidMount(){
  this._lastTransfertsSatellite = this.context?.satellite;
  this.refreshList();
  this.refreshListProcurement();
  this.fetchRegionNames();
  this.fetchCountryNames();
  this.fetchFiscalYears();
  this.fetchProductDescriptions();
  this.fetchWarehouseNames();
  this.fetchProducts();
  this.fetchKits();
  this.fetchProductLables();
  this.fetchSapcodeDupNames();
  this.fetchSapcodeNames();
  this.fetchToWarehouseNames();
  this.fetchTransfertPoDelay();
}

changeCountryName =(e)=>{
  this.setState({countryname:e.target.value});
}


changeRegionName =(e)=>{
  this.setState({regionname:e.target.value});
}

changeFiscalYear =(e)=>{
    this.setState({fyname:e.target.value});
  }

changeProductDescription =(e)=>{
    this.setState({productdescription:e.target.value});
  }


  changeComment =(e)=>{
    this.setState({comment:e.target.value});
  }
  changeJuly =(e)=>{
    this.setState({july:e.target.value});
  }

changeAugust =(e)=>{
    this.setState({august:e.target.value});
  }

changeSeptember =(e)=>{
    this.setState({september:e.target.value});
  }

changeOctober =(e)=>{
    this.setState({october:e.target.value});
  }
changeNovember =(e)=>{
    this.setState({november:e.target.value});
  }

changeDecember =(e)=>{
    this.setState({december:e.target.value});
  }

changeJanuary=(e)=>{
    this.setState({january:e.target.value});
  }

changeFebruary =(e)=>{
    this.setState({february:e.target.value});
  }

changeMarch =(e)=>{
    this.setState({march:e.target.value});
  }

changeApril =(e)=>{
    this.setState({april:e.target.value});
  }

changeMay =(e)=>{
    this.setState({may:e.target.value});
  }

changeJune =(e)=>{
    this.setState({june:e.target.value});
  }


  changePovalidatedJuly = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedjuly: isChecked });
  };


  changePovalidatedAugust = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedaugust: isChecked });
  };

  changePovalidatedSeptember = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedseptember: isChecked });
  };

  changePovalidatedOctober = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedoctober: isChecked });
  };

  changePovalidatedNovember = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatednovember: isChecked });
  };

  changePovalidatedDecember = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidateddecember: isChecked });
  };

  changePovalidatedJanuary = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedjanuary: isChecked });
  };

  changePovalidatedFebruary = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedfebruary: isChecked });
  };

  changePovalidatedMarch = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedmarch: isChecked });
  };

  changePovalidatedApril = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedapril: isChecked });
  };

  changePovalidatedMay = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedmay: isChecked });
  };

  changePovalidatedJune = (event) => {
    const isChecked = event.target.checked;
    this.setState({ povalidatedjune: isChecked });
  };

addClick(){
  this.setState({
      modalTitle:"Add Transfert",
      transfertid:0,
      from_warehousename:"",
      to_warehousename:"",
      fyname:"",
      productdescription:"",
      satellite:"",
      july:"",
      august:"",
      september:"",
      october:"",
      november:"",
      december:"",
      january:"",
      february:"",
      march:"",
      april:"",
      may:"",
      june:"",
      comment:"",
      povalidatedjuly: false,
		  povalidatedaugust: false,
		  povalidatedseptember: false,
		  povalidatedoctober: false,
		  povalidatednovember: false,
		  povalidateddecember: false,
		  povalidatedjanuary: false,
		  povalidatedfebruary: false,
		  povalidatedmarch: false,
		  povalidatedapril: false,
		  povalidatedmay: false,
		  povalidatedjune: false,
      isEditClicked: false,
  });
}


editClick(dep) {
  this.setState({
    modalTitle: "Edit Transfert",
    transfertid: dep.transfertid,
    from_warehousename:dep.from_warehouse.warehousename,
    to_warehousename:dep.to_warehouse.warehousename,
    fyname:dep.year.fyname,
    sapcode:dep.product.sapcode,
    productdescription:dep.product.productdescription,
    satellite: dep.satellite ?? dep.product?.satellite ?? '',
    july:dep.july,
    august:dep.august,
    september:dep.september,
    october:dep.october,
    november:dep.november,
    december:dep.december,
    january:dep.january,
    february:dep.february,
    march:dep.march,
    april:dep.april,
    may:dep.may,
    june:dep.june,
    povalidatedjuly: dep.povalidatedjuly,
		povalidatedaugust: dep.povalidatedaugust,
		povalidatedseptember: dep.povalidatedseptember,
		povalidatedoctober: dep.povalidatedoctober,
		povalidatednovember: dep.povalidatednovember,
		povalidateddecember: dep.povalidateddecember,
		povalidatedjanuary: dep.povalidatedjanuary,
		povalidatedfebruary: dep.povalidatedfebruary,
		povalidatedmarch: dep.povalidatedmarch,
		povalidatedapril: dep.povalidatedapril,
		povalidatedmay: dep.povalidatedmay,
		povalidatedjune: dep.povalidatedjune,
    comment:dep.comment,
    initialFromWarehousename:dep.from_warehouse.warehousename,
    initialToWarehousename:dep.to_warehouse.warehousename,
    initialFyname:dep.year.fyname,
    initialProductdescription:dep.product.productdescription,
    initialSatellite: dep.satellite ?? dep.product?.satellite ?? '',
    initialJuly:dep.july,
    initialAugust:dep.august,
    initialSeptember:dep.september,
    initialOctober:dep.october,
    initialNovember:dep.november,
    initialDecember:dep.december,
    initialJanuary:dep.january,
    initialFebruary:dep.february,
    initialMarch:dep.march,
    initialApril:dep.april,
    initialMay:dep.may,
    initialJune:dep.june,
    initialComment:dep.comment,
    initialPovalidatedjuly: dep.povalidatedjuly,
		initialPovalidatedaugust: dep.povalidatedaugust,
		initialPovalidatedseptember: dep.povalidatedseptember,
		initialPovalidatedoctober: dep.povalidatedoctober,
		initialPovalidatednovember: dep.povalidatednovember,
		initialPovalidateddecember: dep.povalidateddecember,
		initialPovalidatedjanuary: dep.povalidatedjanuary,
		initialPovalidatedfebruary: dep.povalidatedfebruary,
		initialPovalidatedmarch: dep.povalidatedmarch,
		initialPovalidatedapril: dep.povalidatedapril,
		initialPovalidatedmay: dep.povalidatedmay,
		initialPovalidatedjune: dep.povalidatedjune,
    isEditClicked: true,
  });
}

createClick() {
  const { from_warehousename, to_warehousename ,fyname, productdescription, satellite, july, august, september, october,
  november, december, january, february, march, april, may, june, comment,
  povalidatedjuly, povalidatedaugust, povalidatedseptember, povalidatedoctober, povalidatednovember,
  povalidateddecember, povalidatedjanuary, povalidatedfebruary, povalidatedmarch,
  povalidatedapril, povalidatedmay, povalidatedjune } = this.state;

  if (!from_warehousename) {
    alert('FromWarehouse is required');
    return;
  }

  if (!to_warehousename) {
    alert('ToWarehouse is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  if (from_warehousename === to_warehousename) {
    alert('Transfert impossible between the same warehouse');
    return;
  }




  axiosService.post('/transfertscreate/', {
    from_warehousename: from_warehousename,
    to_warehousename: to_warehousename,
    fyname: fyname,
    productdescription:productdescription,
    satellite: satellitePayloadValue(satellite),
    july:july,
    august:august,
    september:september,
    october:october,
    november:november,
    december:december,
    january:january,
    february:february,
    march:march,
    april:april,
    may:may,
    june:june,
    povalidatedjuly: povalidatedjuly,
		  povalidatedaugust: povalidatedaugust,
		  povalidatedseptember: povalidatedseptember,
		  povalidatedoctober: povalidatedoctober,
		  povalidatednovember: povalidatednovember,
		  povalidateddecember: povalidateddecember,
		  povalidatedjanuary: povalidatedjanuary,
		  povalidatedfebruary: povalidatedfebruary,
		  povalidatedmarch: povalidatedmarch,
		  povalidatedapril: povalidatedapril,
		  povalidatedmay: povalidatedmay,
		  povalidatedjune: povalidatedjune,
    comment:comment
  })
    .then(result => {
      alert('Transfert created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const { from_warehousename,to_warehousename, fyname, productdescription, satellite, july, august, september, october,
    november, december, january, february, march, april, may, june,comment, 
    initialFromWarehousename, initialToWarehousename, initialFyname, initialProductdescription, initialSatellite, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune,initialComment,
    povalidatedjuly, povalidatedaugust, povalidatedseptember, povalidatedoctober, povalidatednovember,
    povalidateddecember, povalidatedjanuary, povalidatedfebruary, povalidatedmarch,
    povalidatedapril, povalidatedmay, povalidatedjune,
    initialPovalidatedjuly, initialPovalidatedaugust, initialPovalidatedseptember, initialPovalidatedoctober,
  initialPovalidatednovember, initialPovalidateddecember, initialPovalidatedjanuary, 
  initialPovalidatedfebruary, initialPovalidatedmarch, initialPovalidatedapril, initialPovalidatedmay,
  initialPovalidatedjune   } = this.state;

  if (
    from_warehousename === initialFromWarehousename &&
    to_warehousename === initialToWarehousename &&
    fyname === initialFyname &&
    productdescription === initialProductdescription &&
    satellite === initialSatellite &&
    july === initialJuly &&
    august === initialAugust &&
    september === initialSeptember &&
    october === initialOctober &&
    november === initialNovember &&
    december === initialDecember &&
    january === initialJanuary &&
    february === initialFebruary &&
    march === initialMarch &&
    april === initialApril &&
    may === initialMay &&
    june === initialJune &&
    comment === initialComment &&
    povalidatedjuly === initialPovalidatedjuly &&
    povalidatedaugust === initialPovalidatedaugust &&
    povalidatedseptember === initialPovalidatedseptember &&
    povalidatedoctober === initialPovalidatedoctober &&
    povalidatednovember === initialPovalidatednovember &&
    povalidateddecember === initialPovalidateddecember &&
    povalidatedjanuary === initialPovalidatedjanuary &&
    povalidatedfebruary === initialPovalidatedfebruary &&
    povalidatedmarch === initialPovalidatedmarch &&
    povalidatedapril === initialPovalidatedapril &&
    povalidatedmay === initialPovalidatedmay &&
    povalidatedjune === initialPovalidatedjune
  ) {
    alert('No changes detected');
    return;
  }


  if (!from_warehousename) {
    alert('FromWarehouse is required');
    return;
  }

  if (!to_warehousename) {
    alert('ToWarehouse is required');
    return;
  }

  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  
  axiosService.patch('/transferts/' + id + '/', {
    from_warehousename: this.state.from_warehousename,
    to_warehousename: this.state.to_warehousename,
    fyname: this.state.fyname,
    productdescription : this.state.productdescription,
    satellite: satellitePayloadValue(this.state.satellite),
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june,
    povalidatedjuly: this.state.povalidatedjuly,
		  povalidatedaugust: this.state.povalidatedaugust,
		  povalidatedseptember: this.state.povalidatedseptember,
		  povalidatedoctober: this.state.povalidatedoctober,
		  povalidatednovember: this.state.povalidatednovember,
		  povalidateddecember: this.state.povalidateddecember,
		  povalidatedjanuary: this.state.povalidatedjanuary,
		  povalidatedfebruary: this.state.povalidatedfebruary,
		  povalidatedmarch: this.state.povalidatedmarch,
		  povalidatedapril: this.state.povalidatedapril,
		  povalidatedmay: this.state.povalidatedmay,
		  povalidatedjune: this.state.povalidatedjune,
    comment : this.state.comment
  })
    .then(result => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}



copyClick() {
  const { from_warehousename,to_warehousename, fyname, productdescription, satellite, july, august, september, october,
    november, december, january, february, march, april, may, june,comment, 
    initialFromWarehousename, initialToWarehousename, initialFyname, initialProductdescription, initialSatellite, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune,initialComment,
   povalidatedjuly, povalidatedaugust, povalidatedseptember, povalidatedoctober, povalidatednovember,
    povalidateddecember, povalidatedjanuary, povalidatedfebruary, povalidatedmarch,
    povalidatedapril, povalidatedmay, povalidatedjune  } = this.state;




  if (!from_warehousename) {
    alert('FromWarehouse is required');
    return;
  }

  if (!to_warehousename) {
    alert('ToWarehouse is required');
    return;
  }

  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  
  axiosService.post('/transfertscreate/', {
    from_warehousename: this.state.from_warehousename,
    to_warehousename: this.state.to_warehousename,
    fyname: this.state.fyname,
    productdescription : this.state.productdescription,
    satellite: satellitePayloadValue(this.state.satellite),
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june,
    povalidatedjuly: this.state.povalidatedjuly,
		  povalidatedaugust: this.state.povalidatedaugust,
		  povalidatedseptember: this.state.povalidatedseptember,
		  povalidatedoctober: this.state.povalidatedoctober,
		  povalidatednovember: this.state.povalidatednovember,
		  povalidateddecember: this.state.povalidateddecember,
		  povalidatedjanuary: this.state.povalidatedjanuary,
		  povalidatedfebruary: this.state.povalidatedfebruary,
		  povalidatedmarch: this.state.povalidatedmarch,
		  povalidatedapril: this.state.povalidatedapril,
		  povalidatedmay: this.state.povalidatedmay,
		  povalidatedjune: this.state.povalidatedjune,
    comment : this.state.comment
  })
    .then(result => {
      alert('Transfert created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/transferts/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      transferts,
      modalTitle,
      transfertid,
      from_warehousename,
      to_warehousename,
      fyname,
      productdescription,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      comment,
      povalidatedjuly,
      povalidatedaugust,
      povalidatedseptember,
      povalidatedoctober,
      povalidatednovember,
      povalidateddecember,
      povalidatedjanuary,
      povalidatedfebruary,
      povalidatedmarch,
      povalidatedapril,
      povalidatedmay,
      povalidatedjune,
      products,
      kits,
      productlabelname,
      forecastshistory,
      transfertid_o,
      countryname_o,
      
      comment_o,
      modifiedat_o,
      loading,
      loadingProcurement,
      fiscalYears,

      stockprocurement,

      stockviewid,
      fyname_o,
      regionname_o,
      warehousename_o,
      productdescription_o,
      itemtypename_o,
      july_o,
      august_o,
      september_o,
      october_o,
      november_o,
      december_o,
      january_o,
      february_o,
      march_o,
      april_o,
      may_o,
      june_o,
      isEditClicked

  }=this.state;

    //const currentYear = fiscalYears[currentYearIndex];
    const { fiscalYear, fiscalMonth } = this.getCurrentFinancialYearAndMonth();
    const selectedFiscalYear = parseInt(this.state.fyname, 10);
    const selectedMonthIsJuly = parseInt(7, 10);
    const selectedMonthIsAugust = parseInt(8, 10);
    const selectedMonthIsSeptember = parseInt(9, 10);
    const selectedMonthIsOctober = parseInt(10, 10);
    const selectedMonthIsNovember = parseInt(11, 10);
    const selectedMonthIsDecember = parseInt(12, 10);
  
    const selectedMonthIsJanuary = parseInt(1, 10);
    const selectedMonthIsFebruary = parseInt(2, 10);
    const selectedMonthIsMarch = parseInt(3, 10);
    const selectedMonthIsApril = parseInt(4, 10);
    const selectedMonthIsMay = parseInt(5, 10);
    const selectedMonthIsJune = parseInt(6, 10);
  
    const isDisabledYear = fiscalYear > selectedFiscalYear;
    const isBetweenJulyAndDecember =
    fiscalMonth >= 7 && fiscalMonth <= 12; // Check if fiscal month is between July (6) and November (11) inclusive
    const isBetweenJanuaryAndJune =
    fiscalMonth >= 1 && fiscalMonth <= 6;
  
    const isYearCanBeDisable = selectedFiscalYear <= fiscalYear ; // Check if it's the selected fiscal year
    const isNextYear = (fiscalYear < selectedFiscalYear && selectedFiscalYear <= fiscalYear + 1);
    const isPassedMonthJuly = (fiscalMonth > selectedMonthIsJuly && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsJuly && isBetweenJanuaryAndJune);
    const isDisabledMonthJuly = (isYearCanBeDisable  && isPassedMonthJuly) || isDisabledYear;
    const isPassedMonthAugust = (fiscalMonth > selectedMonthIsAugust && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsAugust && isBetweenJanuaryAndJune);
    const isDisabledMonthAugust = (isYearCanBeDisable && isPassedMonthAugust) || isDisabledYear;
    const isPassedMonthSeptember = (fiscalMonth > selectedMonthIsSeptember && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsSeptember && isBetweenJanuaryAndJune);
    const isDisabledMonthSeptember = (isYearCanBeDisable && isPassedMonthSeptember) || isDisabledYear;
    const isPassedMonthOctober = (fiscalMonth > selectedMonthIsOctober && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsOctober && isBetweenJanuaryAndJune);
    const isDisabledMonthOctober = (isYearCanBeDisable && isPassedMonthOctober) || isDisabledYear;
    const isPassedMonthNovember = (fiscalMonth > selectedMonthIsNovember && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsNovember && isBetweenJanuaryAndJune);
    const isDisabledMonthNovember = (isYearCanBeDisable && isPassedMonthNovember) || isDisabledYear;
    const isPassedMonthDecember =  (fiscalMonth > selectedMonthIsDecember && isBetweenJulyAndDecember) || (fiscalMonth <  selectedMonthIsDecember && isBetweenJanuaryAndJune);
    const isDisabledMonthDecember = (isYearCanBeDisable && isPassedMonthDecember) || isDisabledYear;
  
    const isPassedMonthJanuary =  (fiscalMonth > selectedMonthIsJanuary && isBetweenJanuaryAndJune);
    const isDisabledMonthJanuary = (isYearCanBeDisable && isPassedMonthJanuary) || isDisabledYear;
    const isPassedMonthFebruary = (fiscalMonth > selectedMonthIsFebruary && isBetweenJanuaryAndJune);
    const isDisabledMonthFebruary= (isYearCanBeDisable && isPassedMonthFebruary) || isDisabledYear;
    const isPassedMonthMarch = (fiscalMonth > selectedMonthIsMarch && isBetweenJanuaryAndJune);
    const isDisabledMonthMarch = (isYearCanBeDisable && isPassedMonthMarch) || isDisabledYear;
    const isPassedMonthApril = (fiscalMonth > selectedMonthIsApril && isBetweenJanuaryAndJune);
    const isDisabledMonthApril = (isYearCanBeDisable && isPassedMonthApril) || isDisabledYear;
    const isPassedMonthMay = (fiscalMonth > selectedMonthIsMay && isBetweenJanuaryAndJune);
    const isDisabledMonthMay = (isYearCanBeDisable && isPassedMonthMay) || isDisabledYear;
    const isPassedMonthJune =  (fiscalMonth > selectedMonthIsJune && isBetweenJanuaryAndJune);
    const isDisabledMonthJune = (isYearCanBeDisable  && isPassedMonthJune) || isDisabledYear;

  // Podelay constraints calculationtransfert
  const transfertPoDelay = parseFloat(this.findTransfertPoDelayID(1)) || parseFloat(this.findTransfertPoDelayID(2)) || parseFloat(this.findTransfertPoDelayID(3)) || parseFloat(this.findTransfertPoDelayID(4));

  const monthToOrderTransfert = fiscalMonth + 1 + transfertPoDelay;
  
  const isTolateToMakeOrderMonthJanuaryTransfert = (monthToOrderTransfert > selectedMonthIsJanuary && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsJanuary + 11 && isBetweenJulyAndDecember) ;
  const isTolateToMakeOrderMonthJanuaryTransfertNextYear = (monthToOrderTransfert > selectedMonthIsJanuary + 11 && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsJanuary + 18 && isBetweenJulyAndDecember);
  const isNoOrderMonthJanuaryTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthJanuaryTransfert) || (isNextYear && isTolateToMakeOrderMonthJanuaryTransfertNextYear) || isDisabledYear ;
  
  const isTolateToMakeOrderMonthFebruaryTransfert = (monthToOrderTransfert > selectedMonthIsFebruary && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsFebruary + 11 && isBetweenJulyAndDecember) ;
  const isTolateToMakeOrderMonthFebruaryTransfertNextYear = (monthToOrderTransfert > selectedMonthIsFebruary + 11 && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsFebruary + 18 && isBetweenJulyAndDecember);
  const isNoOrderMonthFebruaryTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthFebruaryTransfert) || (isNextYear && isTolateToMakeOrderMonthFebruaryTransfertNextYear) || isDisabledYear ;
  
  const isTolateToMakeOrderMonthMarchTransfert = (monthToOrderTransfert > selectedMonthIsMarch && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsMarch + 11 && isBetweenJulyAndDecember) ;
  const isTolateToMakeOrderMonthMarchTransfertNextYear = (monthToOrderTransfert > selectedMonthIsMarch + 11 && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsMarch + 18 && isBetweenJulyAndDecember);
  const isNoOrderMonthMarchTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthMarchTransfert) || (isNextYear && isTolateToMakeOrderMonthMarchTransfertNextYear) || isDisabledYear ;
  
  
  const isTolateToMakeOrderMonthAprilTransfert = (monthToOrderTransfert > selectedMonthIsApril && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsApril + 11 && isBetweenJulyAndDecember) ;
  const isTolateToMakeOrderMonthAprilTransfertNextYear = (monthToOrderTransfert > selectedMonthIsApril + 11 && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsApril + 18 && isBetweenJulyAndDecember);
  const isNoOrderMonthAprilTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthAprilTransfert) || (isNextYear && isTolateToMakeOrderMonthAprilTransfertNextYear) || isDisabledYear ;
  
  const isTolateToMakeOrderMonthMayTransfert = (monthToOrderTransfert > selectedMonthIsMay && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsMay + 11 && isBetweenJulyAndDecember) ;
  const isTolateToMakeOrderMonthMayTransfertNextYear = (monthToOrderTransfert > selectedMonthIsMay + 11 && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsMay + 18 && isBetweenJulyAndDecember);
  const isNoOrderMonthMayTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthMayTransfert) || (isNextYear && isTolateToMakeOrderMonthMayTransfertNextYear) || isDisabledYear ;
  
  
  const isTolateToMakeOrderMonthJuneTransfert = (monthToOrderTransfert > selectedMonthIsJune && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsJune + 11 && isBetweenJulyAndDecember) ;
  const isTolateToMakeOrderMonthJuneTransfertNextYear = (monthToOrderTransfert > selectedMonthIsJune + 11 && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsJune + 18 && isBetweenJulyAndDecember);
  const isNoOrderMonthJuneTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthJuneTransfert) || (isNextYear && isTolateToMakeOrderMonthJuneTransfertNextYear) || isDisabledYear ;
  
  
  const isTolateToMakeOrderMonthJulyTransfert = (monthToOrderTransfert > selectedMonthIsJuly && isBetweenJulyAndDecember) || isBetweenJanuaryAndJune;
  const isTolateToMakeOrderMonthJulyTransfertNextYear = (monthToOrderTransfert > selectedMonthIsJuly && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsNovember && isBetweenJulyAndDecember);
  const isNoOrderMonthJulyTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthJulyTransfert) || (isNextYear && isTolateToMakeOrderMonthJulyTransfertNextYear) || isDisabledYear ;
  
  const isTolateToMakeOrderMonthAugustTransfert = (monthToOrderTransfert > selectedMonthIsAugust && isBetweenJulyAndDecember) || isBetweenJanuaryAndJune ;
  const isTolateToMakeOrderMonthAugustTransfertNextYear = (monthToOrderTransfert > selectedMonthIsAugust && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsNovember && isBetweenJulyAndDecember);
  const isNoOrderMonthAugustTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthAugustTransfert) || (isNextYear && isTolateToMakeOrderMonthAugustTransfertNextYear) || isDisabledYear ;
  
  
  const isTolateToMakeOrderMonthSeptemberTransfert = (monthToOrderTransfert > selectedMonthIsSeptember && isBetweenJulyAndDecember) || isBetweenJanuaryAndJune ;
  const isTolateToMakeOrderMonthSeptemberTransfertNextYear = (monthToOrderTransfert > selectedMonthIsSeptember && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsNovember && isBetweenJulyAndDecember);
  const isNoOrderMonthSeptemberTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthSeptemberTransfert) || (isNextYear && isTolateToMakeOrderMonthSeptemberTransfertNextYear) || isDisabledYear ;
  
  
  const isTolateToMakeOrderMonthOctoberTransfert = (monthToOrderTransfert > selectedMonthIsOctober && isBetweenJulyAndDecember) || isBetweenJanuaryAndJune ;
  const isTolateToMakeOrderMonthOctoberTransfertNextYear = (monthToOrderTransfert > selectedMonthIsOctober && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsNovember && isBetweenJulyAndDecember);
  const isNoOrderMonthOctoberTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthOctoberTransfert) || (isNextYear && isTolateToMakeOrderMonthOctoberTransfertNextYear) || isDisabledYear ;
  
  const isTolateToMakeOrderMonthNovemberTransfert = (monthToOrderTransfert > selectedMonthIsNovember && isBetweenJulyAndDecember) || isBetweenJanuaryAndJune ;
  const isTolateToMakeOrderMonthNovemberTransfertNextYear = (monthToOrderTransfert > selectedMonthIsNovember && isBetweenJanuaryAndJune) || (monthToOrderTransfert > selectedMonthIsNovember && isBetweenJulyAndDecember);
  const isNoOrderMonthNovemberTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthNovemberTransfert) || (isNextYear && isTolateToMakeOrderMonthNovemberTransfertNextYear) || isDisabledYear ;
  
  
  const isTolateToMakeOrderMonthDecemberTransfert = (monthToOrderTransfert > selectedMonthIsDecember && isBetweenJulyAndDecember) || isBetweenJanuaryAndJune ;
  const isTolateToMakeOrderMonthDecemberTransfertNextYear = (monthToOrderTransfert > selectedMonthIsDecember && isBetweenJanuaryAndJune);
  const isNoOrderMonthDecemberTransfert =  (isYearCanBeDisable && isTolateToMakeOrderMonthDecemberTransfert) || (isNextYear && isTolateToMakeOrderMonthDecemberTransfertNextYear) || isDisabledYear ;
  
  return(
    
<div className="scrollable-container" >
<MyPage />
<SubTabsWarehouses />
<button type="button"
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add Transfert
</button>
<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Transferts
    </div>
  
<div className="table-container">
<table className="table table-striped" >
<thead>
<tr  className="header-row-fixed">

  <th  style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center"
      
      >
      <input className="form-control m-2"
      style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeTransfertIdFilter}
      placeholder="Filter"/>

      </div>
      TransfertId
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "90px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductIdFilter}
      placeholder="Filter"/>
      </div>
      SAP Code / SKU
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Satellite
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionFilter}
      placeholder="Filter"/>

      </div>
      Product
  </th>


  <th style={{ fontSize: "12px", textAlign: "center" }}>
    <div className="d-flex flex-row align-items-center justify-content-center">
      <input
        className="form-control m-2"
        style={{ width: "100px", height: "30px", fontSize: "12px" }}
        onChange={this.changeItemTypeFilter}
        placeholder="Filter"
      />
    </div>
    ItemType
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      placeholder="Filter"/>
      </div>
      Fiscal Year
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFromWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      From Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeToWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      To Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeTransfertCommentFilter}
      placeholder="Filter"/>
      </div>
      Comments
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {transferts.map(dep=>
      <tr key={dep.transfertid} className="row-hover">
          <td className="table-text">{dep.transfertid}</td>
          <td className="table-text">{dep.product?.sapcode ?? 'N/A'}</td>
          <td className="table-text">{displaySatellite(dep.satellite ?? dep.product?.satellite, { csv: true })}</td>
          <td className="table-text">{dep.product?.productdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.product?.itemtype?.itemtypename ?? 'N/A'}</td>
          <td className="table-text">{dep.year?.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.from_warehouse?.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.to_warehouse?.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.comment ?? 'N/A'}</td>
          <td className="table-text">{dep.july ?? 'N/A'}</td>
          <td className="table-text">{dep.august ?? 'N/A'}</td>
          <td className="table-text">{dep.september ?? 'N/A'}</td>
          <td className="table-text">{dep.october ?? 'N/A'}</td>
          <td className="table-text">{dep.november ?? 'N/A'}</td>
          <td className="table-text">{dep.december ?? 'N/A'}</td>
          <td className="table-text">{dep.january ?? 'N/A'}</td>
          <td className="table-text">{dep.february ?? 'N/A'}</td>
          <td className="table-text">{dep.march ?? 'N/A'}</td>
          <td className="table-text">{dep.april ?? 'N/A'}</td>
          <td className="table-text">{dep.may ?? 'N/A'}</td>
          <td className="table-text">{dep.june ?? 'N/A'}</td>
          <td className="table-text">

          <div style={{ display: "flex", justifyContent: "center" }}>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal2"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.transfertid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          </div>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>


<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Stock&Procurement
    </div>
<div className="table-container-fixsize">
<table className="table-fixsize table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearOFilter}
      
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameOFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductIdOFilter}
      placeholder="Filter"/>
      </div>
      Product SAP Code / SKU
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Satellite
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionOFilter}
      placeholder="Filter"/>
      </div>
      ProductDescription
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItemTypeNameOFilter}
      placeholder="Filter"/>

      </div>
      ItemType
  </th>

<th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex m-2 flex-row align-items-center justify-content-center gap-1">
    <button 
      type="button"
      className="btn btn-primary"
      style={{ fontSize: "12px" }}
      onClick={this.searchStockProcurement}
    >
      Search
    </button>
    <button 
      type="button"
      className="btn btn-secondary"
      style={{ fontSize: "12px" }}
      onClick={this.clearFiltersProcurement}
    >
      Clear
    </button>
  </div>
  Jul
</th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
  disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('august_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('august_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('september_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('september_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('october_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('october_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('november_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('november_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('december_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('december_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('january_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('january_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('february_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('february_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('march_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('march_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('april_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('april_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('may_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('may_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('june_o',true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
          </svg>
      </button>

      <button type="button" className="btn btn-light"
      disabled={!isSuperAdmin()}
      onClick={()=>this.sortResultO('june_o',false)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
          <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
          </svg>
      </button>
      </div>
      Jun
  </th>
</tr>
</thead>
{loadingProcurement ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {stockprocurement.map(dep=>
      <tr key={dep.stockviewid} className="row-hover">
          <td className="table-text">{dep.fyname_o ?? 'N/A'}</td>
          <td className="table-text">{dep.warehousename_o ?? 'N/A'}</td>
          <td className="table-text">{dep.sapcode_o ?? 'N/A'}</td>
          <td className="table-text">{dep.satellite_o ?? 'N/A'}</td>
          <td className="table-text">{dep.productdescription_o ?? 'N/A'}</td>
          <td className="table-text">{dep.itemtypename_o ?? 'N/A'}</td>
          <td className="table-text">{dep.july_o ?? 'N/A'}</td>
          <td className="table-text">{dep.august_o?? 'N/A'}</td>
          <td className="table-text">{dep.september_o ?? 'N/A'}</td>
          <td className="table-text">{dep.october_o ?? 'N/A'}</td>
          <td className="table-text">{dep.november_o ?? 'N/A'}</td>
          <td className="table-text">{dep.december_o ?? 'N/A'}</td>
          <td className="table-text">{dep.january_o ?? 'N/A'}</td>
          <td className="table-text">{dep.february_o ?? 'N/A'}</td>
          <td className="table-text">{dep.march_o ?? 'N/A'}</td>
          <td className="table-text">{dep.april_o ?? 'N/A'}</td>
          <td className="table-text">{dep.may_o ?? 'N/A'}</td>
          <td className="table-text">{dep.june_o ?? 'N/A'}</td>
          <td>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
<div style={{ 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center', 
  gap: '10px', 
  padding: '20px',
  fontSize: '12px'
}}>
  <button 
    onClick={this.handlePreviousPageProcurement}
    disabled={!this.state.previousPageUrlProcurement || this.state.loadingProcurement}
    className="btn btn-primary"
    style={{ height: "28px", fontSize: "12px" }}
  >
    Previous
  </button>
  
  <span style={{ fontSize: '12px' }}>
    Page {this.state.currentPageProcurement} of {this.state.totalPagesProcurement}
  </span>
  
  <button 
    onClick={this.handleNextPageProcurement}
    disabled={!this.state.nextPageUrlProcurement || this.state.loadingProcurement}
    className="btn btn-primary"
    style={{ height: "28px", fontSize: "12px" }}
  >
    Next
  </button>
</div>
</div>
<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
          
        { !isDisabledYear  && (
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >From Warehouse</span>
          <select
            className="form-select"
            value={this.state.from_warehousename}
            onChange={(event) => this.setState({ from_warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select from warehouse</option>
            {this.state.warehouseNames.filter((warehouse) => warehouse !== this.state.to_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>
 )}
{ !isDisabledYear  && (       
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >To Warehouse</span>
          <select
            className="form-select"
            value={this.state.to_warehousename}
            onChange={(event) => this.setState({ to_warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select to warehouse</option>
            {this.state.toWarehouseNames.filter((warehouse) => warehouse !== this.state.from_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>
        )}
        { !isDisabledYear  && (
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ProductType</span>
          <select
            className="form-select"
            value={this.state.productlabelname}
            onChange={(event) => this.setState({ productlabelname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select productType</option>
            {this.state.productLabels.map((productlabel) => (
              <option key={productlabel} value={productlabel}>
                {productlabel}
              </option>
            ))}
          </select>
        </div>
 )}
 
{this.state.productlabelname === "FULL" && !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode= event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcodeDup(selectedSapcode);
      const satellite = this.findSatelliteForSapcodeDup(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select kit SAPCODE</option>
    {this.state.SapcodeDupNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>

)}

{this.state.productlabelname === "FULL" && !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}

{this.state.productlabelname === "UNIT" && !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      const satellite = this.findSatelliteForSapcode(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>
)}


{this.state.productlabelname === "UNIT" && !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}


{ !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Transfert PoDelay(months)</span>
  <input
    type="text"
    className="form-control"
    value={transfertPoDelay}
    disabled={true}
    style={{ fontSize: "12px" }}
  />
</div>

)}

{ !isDisabledYear  && (
        <>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Satellite</span>
          <input
            type="text"
            className="form-control"
            value={this.state.satellite}
            onChange={(e) => this.setState({ satellite: e.target.value })}
            placeholder="e.g. GEO, LEO"
            style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Comments</span>
          <input type="text" className="form-control" value={comment} onChange={this.changeComment} 
          style={{ fontSize: "12px" }} 
          />
        </div>
        </>
)}

{this.state.fyname  && !isNoOrderMonthJulyTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>July</span>
              <input type="text" className="form-control" value={july} onChange={this.changeJuly} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedjuly}
            onChange={this.changePovalidatedJuly}
            disabled={!july} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthAugustTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>August</span>
              <input type="text" className="form-control" value={august} onChange={this.changeAugust} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedaugust}
            onChange={this.changePovalidatedAugust}
            disabled={!august} 
          />
        </div>
          </div>
        </div>

)}
        

        {this.state.fyname  && !isNoOrderMonthSeptemberTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>September</span>
              <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedseptember}
            onChange={this.changePovalidatedSeptember}
            disabled={!september} 
          />
        </div>
          </div>
        </div>

)}
        

        {this.state.fyname  && !isNoOrderMonthOctoberTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>October</span>
              <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedoctober}
            onChange={this.changePovalidatedOctober}
            disabled={!october} 
          />
        </div>
          </div>
        </div>

)}
     

     {this.state.fyname  && !isNoOrderMonthNovemberTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>November</span>
              <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatednovember}
            onChange={this.changePovalidatedNovember}
            disabled={!november} 
          />
        </div>
          </div>
        </div>

)}
     

     {this.state.fyname  && !isNoOrderMonthDecemberTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>December</span>
              <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidateddecember}
            onChange={this.changePovalidatedDecember}
            disabled={!december} 
          />
        </div>
          </div>
        </div>

)}
        
        {this.state.fyname  && !isNoOrderMonthJanuaryTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>January</span>
              <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedjanuary}
            onChange={this.changePovalidatedJanuary}
            disabled={!january} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthFebruaryTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>February</span>
              <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedfebruary}
            onChange={this.changePovalidatedFebruary}
            disabled={!february} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthMarchTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>March</span>
              <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedmarch}
            onChange={this.changePovalidatedMarch}
            disabled={!march} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthAprilTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>April</span>
              <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedapril}
            onChange={this.changePovalidatedApril}
            disabled={!april} 
          />
        </div>
          </div>
        </div>

)}


{this.state.fyname  && !isNoOrderMonthMayTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
              <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedmay}
            onChange={this.changePovalidatedMay}
            disabled={!may} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthJuneTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>June</span>
              <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedjune}
            onChange={this.changePovalidatedJune}
            disabled={!june} 
          />
        </div>
          </div>
        </div>

)}


        {transfertid === 0 && (july || august || september || october || november || december ||
        january || february || march || april || may || june ) ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {transfertid !== 0 && (july || august || september || october || november || december ||
        january || february || march || april || may || june ) ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(transfertid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
        

      
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >From Warehouse</span>
          <select
            className="form-select"
            value={this.state.from_warehousename}
            onChange={(event) => this.setState({ from_warehousename: event.target.value })}
           
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select from warehouse</option>
            {this.state.warehouseNames.filter((warehouse) => warehouse !== this.state.to_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >To Warehouse</span>
          <select
            className="form-select"
            value={this.state.to_warehousename}
            onChange={(event) => this.setState({ to_warehousename: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select to warehouse</option>
            {this.state.toWarehouseNames.filter((warehouse) => warehouse !== this.state.from_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ProductType</span>
          <select
            className="form-select"
            value={this.state.productlabelname}
            onChange={(event) => this.setState({ productlabelname: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select productType</option>
            {this.state.productLabels.map((productlabel) => (
              <option key={productlabel} value={productlabel}>
                {productlabel}
              </option>
            ))}
          </select>
        </div>

 
{this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode= event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcodeDup(selectedSapcode);
      const satellite = this.findSatelliteForSapcodeDup(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
    
    style={{ fontSize: "12px" }}
  >
    <option value="">Select kit SAPCODE</option>
    {this.state.SapcodeDupNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>

)}

{this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}

{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      const satellite = this.findSatelliteForSapcode(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
    
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>
)}


{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}





        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Satellite</span>
          <input
            type="text"
            className="form-control"
            value={this.state.satellite}
            onChange={(e) => this.setState({ satellite: e.target.value })}
            placeholder="e.g. GEO, LEO"
            style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Comments</span>
          <input type="text" className="form-control" value={comment} onChange={this.changeComment} 
          style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }} 
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {transfertid === 0 && (july || august || september || october || november || december ||
        january || february || march || april || may || june ) ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}

        {transfertid !== 0 && (july || august || september || october || november || december ||
        january || february || march || april || may || june ) ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal2" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
          
        { !isDisabledYear  && (
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >From Warehouse</span>
          <select
            className="form-select"
            value={this.state.from_warehousename}
            onChange={(event) => this.setState({ from_warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select from warehouse</option>
            {this.state.warehouseNames.filter((warehouse) => warehouse !== this.state.to_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>
 )}
{ !isDisabledYear  && (       
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >To Warehouse</span>
          <select
            className="form-select"
            value={this.state.to_warehousename}
            onChange={(event) => this.setState({ to_warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select to warehouse</option>
            {this.state.toWarehouseNames.filter((warehouse) => warehouse !== this.state.from_warehousename).map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>
        )}
        { !isDisabledYear  && (
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ProductType</span>
          <select
            className="form-select"
            value={this.state.productlabelname}
            onChange={(event) => this.setState({ productlabelname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select productType</option>
            {this.state.productLabels.map((productlabel) => (
              <option key={productlabel} value={productlabel}>
                {productlabel}
              </option>
            ))}
          </select>
        </div>
 )}
 
{this.state.productlabelname === "FULL" && !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode= event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcodeDup(selectedSapcode);
      const satellite = this.findSatelliteForSapcodeDup(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select kit SAPCODE</option>
    {this.state.SapcodeDupNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>

)}

{this.state.productlabelname === "FULL" && !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}

{this.state.productlabelname === "UNIT" && !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      const satellite = this.findSatelliteForSapcode(selectedSapcode);
      this.setState({ productdescription, satellite });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>
)}


{this.state.productlabelname === "UNIT" && !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}


{ !isDisabledYear  && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Transfert PoDelay(months)</span>
  <input
    type="text"
    className="form-control"
    value={transfertPoDelay}
    disabled={true}
    style={{ fontSize: "12px" }}
  />
</div>

)}

{ !isDisabledYear  && (
        <>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Satellite</span>
          <input
            type="text"
            className="form-control"
            value={this.state.satellite}
            onChange={(e) => this.setState({ satellite: e.target.value })}
            placeholder="e.g. GEO, LEO"
            style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Comments</span>
          <input type="text" className="form-control" value={comment} onChange={this.changeComment} 
          style={{ fontSize: "12px" }} 
          />
        </div>
        </>
)}

{this.state.fyname  && !isNoOrderMonthJulyTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>July</span>
              <input type="text" className="form-control" value={july} onChange={this.changeJuly} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedjuly}
            onChange={this.changePovalidatedJuly}
            disabled={!july} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthAugustTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>August</span>
              <input type="text" className="form-control" value={august} onChange={this.changeAugust} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedaugust}
            onChange={this.changePovalidatedAugust}
            disabled={!august} 
          />
        </div>
          </div>
        </div>

)}
        

        {this.state.fyname  && !isNoOrderMonthSeptemberTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>September</span>
              <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedseptember}
            onChange={this.changePovalidatedSeptember}
            disabled={!september} 
          />
        </div>
          </div>
        </div>

)}
        

        {this.state.fyname  && !isNoOrderMonthOctoberTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>October</span>
              <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedoctober}
            onChange={this.changePovalidatedOctober}
            disabled={!october} 
          />
        </div>
          </div>
        </div>

)}
     

     {this.state.fyname  && !isNoOrderMonthNovemberTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>November</span>
              <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatednovember}
            onChange={this.changePovalidatedNovember}
            disabled={!november} 
          />
        </div>
          </div>
        </div>

)}
     

     {this.state.fyname  && !isNoOrderMonthDecemberTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>December</span>
              <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidateddecember}
            onChange={this.changePovalidatedDecember}
            disabled={!december} 
          />
        </div>
          </div>
        </div>

)}
        
        {this.state.fyname  && !isNoOrderMonthJanuaryTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>January</span>
              <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedjanuary}
            onChange={this.changePovalidatedJanuary}
            disabled={!january} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthFebruaryTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>February</span>
              <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedfebruary}
            onChange={this.changePovalidatedFebruary}
            disabled={!february} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthMarchTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>March</span>
              <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedmarch}
            onChange={this.changePovalidatedMarch}
            disabled={!march} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthAprilTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>April</span>
              <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedapril}
            onChange={this.changePovalidatedApril}
            disabled={!april} 
          />
        </div>
          </div>
        </div>

)}


{this.state.fyname  && !isNoOrderMonthMayTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
              <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedmay}
            onChange={this.changePovalidatedMay}
            disabled={!may} 
          />
        </div>
          </div>
        </div>

)}

{this.state.fyname  && !isNoOrderMonthJuneTransfert  && (<div className="row">
          <div className="col">
            <div className="input-group mb-3">
              <span className="input-group-text" style={{ fontSize: "12px" }}>June</span>
              <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          
          style={{ fontSize: "12px" }}
          />
            </div>
          </div>
          <div className="col">
          <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >PoValidated</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={povalidatedjune}
            onChange={this.changePovalidatedJune}
            disabled={!june} 
          />
        </div>
          </div>
        </div>

)}

        {transfertid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {transfertid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(transfertid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
  }




